// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"53206dfb","377":"53206dfb","690":"53206dfb"}[chunkId] + ".chunk.css";
};